export const LOADING_EMPLOYEE = "LOADING_EMPLOYEE";
export const GET_EMPLOYEE_LIST = "GET_EMPLOYEE_LIST";
export const REMOVE_EMPLOYEE = "REMOVE_EMPLOYEE";
export const ADD_EMPLOYEE = "ADD_EMPLOYEE";
export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE";
export const GET_EMPLOYEEID = "GET_EMPLOYEEID";

//#region Document

export const LOADING_EMPLOYEE_DOC = "LOADING_EMPLOYEE_DOC";
export const GET_EMPLOYEE_LIST_DOC = "GET_EMPLOYEE_LIST_DOC";
export const REMOVE_EMPLOYEE_DOC = "REMOVE_EMPLOYEE_DOC";
export const ADD_EMPLOYEE_DOC = "ADD_EMPLOYEE_DOC";
export const UPDATE_EMPLOYEE_DOC = "UPDATE_EMPLOYEE_DOC";
export const GET_EMPLOYEEID_DOC = "GET_EMPLOYEEID_DOC";

//#endregion